export default __webpack_public_path__ + "assets/fonts/72b14f079ab807fc06db7844aa193d5d.woff2";